import type { TripPlannerDetails } from "../TripPlannerProvider";

export function makeDefaultTripTitle(places: TripPlannerDetails["places"]) {
  return places.map(({ shortName }) => shortName).join(" - ");
}
